import { ICostReport } from 'features/cost-analysis/cost-report/types';
import { BaseService } from 'shared/services/BaseService';

class CostReportService extends BaseService<ICostReport> {
  constructor() {
    super('cost-analyses');
  }
  canDelete = true;
}

export const costReportService = new CostReportService();
